import { DropDownList } from "@progress/kendo-react-dropdowns";
import { InputField } from "../../components/form/input.field.component";
import { API_END_POINT } from "../../constants";
import { FormikModelDialog, SubmitStatus } from "../../core/formik-model-dialog.component";
import UnionsModel from "../../models/masters/unions-model";
import * as Yup from "yup";
import { TextArea } from "@progress/kendo-react-inputs";
import { useEffect, useState } from "react";
import { useGetUnions } from "../../apiclient/master/useGetUnionsApi";

interface UnionsEditProps {
    data: UnionsModel;
    isViewMode?: boolean; 
    onClose?: (status: SubmitStatus, data: any) => any;
}


const UnionsEntry: React.FC<UnionsEditProps> = ({ ...props }) => {
    let { data, onClose,isViewMode } = props;
    const title = data?.unionId > 0 ? "Edit Unions" : "Add Unions";

    let initialValue: UnionsModel = {
        unionId: data?.unionId ? data.unionId : 0,
        name: data?.name,
        shortName: data?.shortName,
        address: data?.address,
    };
    const validationSchema = Yup.object().shape({
        name: Yup.string()
        .required("Required")
        .test("check-duplicate-name", "Union name already exists", (value) => {
          // Ensure the value is compared in a case-insensitive manner
          return (
            value &&
            !existingName.some(existing => existing.toLowerCase() === value.toLowerCase()) ||
            (data?.name && value === data.name) // Allow current name during update
          );
        }), 
        shortName: Yup.string()
        .required("Required")
        .test("check-duplicate-shortName", "Short Name already exists", (value) => {
          return (
            value &&
            (!existingShortName.some(
              (existing) =>
                existing && value.toLowerCase() === existing.toLowerCase()
            ) || (data?.shortName && value === data.shortName))
          );
        }),
});

const [existingName, setExistingName] = useState<string[]>([]); 
const [existingShortName, setExistingShortName] = useState<string[]>([]);

const { data: fetchedUnions } = useGetUnions(); // Fetching existing zones data

useEffect(() => {
    if (fetchedUnions) {
        setExistingName(fetchedUnions.map((zone: any) => zone.name)); // Extracting zone names to compare against
        setExistingShortName(
            fetchedUnions.map((union: any) => union.shortName).filter((v) => !!v)
          );
    }
}, [fetchedUnions]);



    return (
        <>
            <FormikModelDialog
                width="50%"
                title={title}
                initialData={initialValue}
                validationSchema={validationSchema}
                show={!!data}
                onClose={onClose}
                endpoint={API_END_POINT.MASTER}
                postRoute="Unions/SaveUnions"
                showAddAnother={true}
                isViewOnly ={isViewMode}
                isUpDateEntityDetails={data?.unionId>0? true: false}
            >
                <div>
                    <div className="row">
                        <div className="col-3">
                            <InputField maxLength={100} label="Union *" name="name" />
                        </div>
                        <div className="col-6">
                            <InputField maxLength={100} label="Short Name" name="shortName" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <InputField maxLength={100} label="Address" name="address" />                       
                        </div>
                    </div>

                </div>
            </FormikModelDialog>
        </>
    );
};


export default UnionsEntry;